var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_401"},[_c('div',{staticClass:"info"},[_c('p',[_vm._v("哎呀，没有权限访问！")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }